@if (showButton(FUNCTION.SAVE_MODEL)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.SAVE_MODEL]" [disabled]="!isUnsavedChanges()" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}
@if (showButton(FUNCTION.DOWNLOAD_MODEL)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.DOWNLOAD_MODEL]" [triggerFor]="downloadMenu" [dropdown]="dropdown"></app-toolbar-button>
}
@if (showButton(FUNCTION.REPLACE_CURRENT_STATE) && canReplaceCurrentState()) {
  <app-toolbar-button [function]="functionMap[FUNCTION.REPLACE_CURRENT_STATE]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)" [disabled]="isUnsavedChanges()"></app-toolbar-button>
}
@if (showButton(FUNCTION.BACKUP_MODEL)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.BACKUP_MODEL]" [disabled]="isUnsavedChanges()" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}
@if (showButton(FUNCTION.RESTORE_BACKUP)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.RESTORE_BACKUP]" [disabled]="isUnsavedChanges() || noBackups()" [dropdown]="dropdown"  [triggerFor]="backupMenu"></app-toolbar-button>
}

<mat-menu #backupMenu="matMenu">
  @for (backup of getBackups(); track backup._key) {
    <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.RESTORE_BACKUP], backup._key)">
      <span>{{backup.date | date:'d/M/yy, h:mm a'}}</span>
    </button>
  }
</mat-menu>

<mat-menu #downloadMenu="matMenu">
  <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.DOWNLOAD_MODEL], EXPORT_TYPE.JSON)">
    <mat-icon>download</mat-icon>
    Download JSon
  </button>
  <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.DOWNLOAD_MODEL], EXPORT_TYPE.CSV)">
    <mat-icon>download</mat-icon>
    Download CSV
  </button>
  <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.DOWNLOAD_MODEL], EXPORT_TYPE.SYSTEM_HOURS_CSV)">
    <mat-icon>download</mat-icon>
    Download system hours CSV
  </button>
  <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.DOWNLOAD_MODEL], EXPORT_TYPE.ROLE_HOURS_CSV)">
    <mat-icon>download</mat-icon>
    Download role hours CSV
  </button>
  <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.DOWNLOAD_MODEL], EXPORT_TYPE.PNG)">
    <mat-icon>image</mat-icon>
    Export image as png
  </button>
    <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.DOWNLOAD_MODEL], EXPORT_TYPE.JPG)">
    <mat-icon>image</mat-icon>
    Export image as jpg
  </button>
  <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.DOWNLOAD_MODEL], EXPORT_TYPE.PDF)">
    <mat-icon>image</mat-icon>
    Export PDF
  </button>
</mat-menu>

@if (!linqset.isTutorial()) {
  @if (!dropdown) {
    <div class="demo-separator"></div>
  }
  @if (dropdown) {
    <mat-divider></mat-divider>
  }
}
@if (showButton(FUNCTION.TOGGLE_MAGNIFYING_GLASS)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.TOGGLE_MAGNIFYING_GLASS]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}
@if (showButton(FUNCTION.ZOOM_IN)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.ZOOM_IN]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}
@if (showButton(FUNCTION.ZOOM_OUT)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.ZOOM_OUT]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}
@if (showButton(FUNCTION.RETURN_TO_ORIGINAL)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.RETURN_TO_ORIGINAL]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}
@if (showButton(FUNCTION.FIT_TO_SCREEN)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.FIT_TO_SCREEN]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}
@if (showButton(FUNCTION.RESET_LAYOUT)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.RESET_LAYOUT]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)" [highlight]="isHighlight(FUNCTION.RESET_LAYOUT)"></app-toolbar-button>
}
@if (showButton(FUNCTION.INCREMENTAL_LAYOUT)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.INCREMENTAL_LAYOUT]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)" [highlight]="isHighlight(FUNCTION.INCREMENTAL_LAYOUT)"></app-toolbar-button>
}
@if (showButton(FUNCTION.TOGGLE_VIEW_DIRECTION)) {
  <app-toolbar-button name="Change view direction" ariaLabel="Select from list of directions for the graph" [triggerFor]="viewDirectionMenu" icon="change_circle" [disabled]="isDisabled(FUNCTION.TOGGLE_VIEW_DIRECTION)" [dropdown]="dropdown"></app-toolbar-button>
  <mat-menu #viewDirectionMenu="matMenu">
    <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.TOGGLE_VIEW_DIRECTION], LAYOUT_DIRECTION.UP)">
      <mat-icon>arrow_upward</mat-icon>
      <span>Bottom up</span>
    </button>
    <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.TOGGLE_VIEW_DIRECTION], LAYOUT_DIRECTION.DOWN)">
      <mat-icon>arrow_downward</mat-icon>
      <span>Top down</span>
    </button>
    <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.TOGGLE_VIEW_DIRECTION], LAYOUT_DIRECTION.LEFT_RIGHT)">
      <mat-icon>arrow_forward</mat-icon>
      <span>Left to right</span>
    </button>
    <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.TOGGLE_VIEW_DIRECTION], LAYOUT_DIRECTION.RIGHT_LEFT)">
      <mat-icon>arrow_back</mat-icon>
      <span>Right to left</span>
    </button>
  </mat-menu>
}

@if (showButton(FUNCTION.CHANGE_MODEL_TYPE)) {
  <app-toolbar-button name="Model view" ariaLabel="Select different model views"  [triggerFor]="modelTypeMenu" [icon]="'graph_2'" [dropdown]="dropdown" [disabled]="isGrouped"></app-toolbar-button>
}

<mat-menu #modelTypeMenu="matMenu">
  @for (t of modelTypes; track t) {
    <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.CHANGE_MODEL_TYPE], t)">
      <mat-icon>{{t === currentModelType && !comparing ? 'check' : ''}}</mat-icon>
      <span>{{t.toString()}}</span>
    </button>
  }
  <!-- a project's changed model over the same model in current state -->
  @if (canCompare) {
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.COMPARE_WITH_CURRENT_STATE])" [matTooltip]="functionMap[FUNCTION.COMPARE_WITH_CURRENT_STATE].description" data-testid="compare-with-current-state">
      <mat-icon>{{comparing ? 'check' : ''}}</mat-icon>
      <span>Comparison with current state</span>
    </button>
  }
</mat-menu>

@if (showButton(FUNCTION.CHANGE_LAYOUT)) {
  <app-toolbar-button name="Layout" ariaLabel="Select different layouts"  [triggerFor]="layoutMenu" [icon]="'modeling'" [dropdown]="dropdown" [disabled]="isGrouped"></app-toolbar-button>
}

<mat-menu #layoutMenu="matMenu">
  @for (l of layouts; track l) {
    <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.CHANGE_LAYOUT], l)">
      <mat-icon>{{l === linqset?.layout ? 'check' : ''}}</mat-icon>
      <span>{{l.toString()}}</span>
    </button>
  }
  <!-- with a tag group shown, the model can be lined up along the nodes with one of its tags. The tags are listed here
       rather than in a menu of their own, which (inside "More model functions") would be a third menu with nowhere to go -->
  @if (selectedTagGroup?.tags?.length) {
    <mat-divider></mat-divider>
    <div class="menu-section-label" data-testid="tag-path-layout">Line up a tag's path ({{selectedTagGroup.name}})</div>
    @for (t of selectedTagGroup.tags; track t._key) {
      <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.CHANGE_LAYOUT], {layout: LAYOUTS.HIERARCHIC_TAG, groupKey: selectedTagGroup._key, tagKey: t._key})"
        [matTooltip]="'Line the model up along the nodes tagged ' + t.name" matTooltipPosition="right">
        <mat-icon>{{isTagPath(t._key) ? 'check' : ''}}</mat-icon>
        <i class="fa fa-solid fa-tag tag-icon" [style]="tagColour(t)"></i>
        <span>{{t.name}}</span>
      </button>
    }
  }
</mat-menu>

@if (!linqset.isTutorial()) {
  @if (!dropdown) {
    <div class="demo-separator"></div>
  }
  @if (dropdown && !app.mediumScreen) {
    <mat-divider></mat-divider>
  }
}

@if (showButton(FUNCTION.SWITCH_TO_PAN_MODE)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.SWITCH_TO_PAN_MODE]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}
@if (showButton(FUNCTION.SWITCH_TO_SELECT_MODE)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.SWITCH_TO_SELECT_MODE]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}

@if (!app.mediumScreen && !linqset.isTutorial()) {
  @if (!dropdown && !app.largeScreen) {
    <div class="demo-separator"></div>
  }
  @if (dropdown) {
    <mat-divider></mat-divider>
  }
}

@if (showButton(FUNCTION.CUT)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.CUT]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}
@if (showButton(FUNCTION.COPY)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.COPY]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}
@if (showButton(FUNCTION.PASTE)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.PASTE]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}

@if (!app.mediumScreen && !linqset.isTutorial()) {
  @if (!dropdown && !readonlyGraph) {
    <div class="demo-separator"></div>
  }
  @if (dropdown && !readonlyGraph) {
    <mat-divider></mat-divider>
  }
}

@if (showButton(FUNCTION.UNDO)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.UNDO]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}
@if (showButton(FUNCTION.REDO)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.REDO]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}

  @if (!dropdown && !readonlyGraph) {
    <div class="demo-separator"></div>
  }
  @if (dropdown && !readonlyGraph) {
    <mat-divider></mat-divider>
  }

  @if (showButton(FUNCTION.COLLAPSE_ALL)) {
    <app-toolbar-button [function]="functionMap[FUNCTION.COLLAPSE_ALL]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
  }
  @if (showButton(FUNCTION.EXPAND_ALL)) {
    <app-toolbar-button [function]="functionMap[FUNCTION.EXPAND_ALL]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
  }

  @if (showButton(FUNCTION.CREATE_GROUPS)) {
    <app-toolbar-button name="Groups" ariaLabel="Organise groups menu"  [triggerFor]="groupItemsMenu" [disabled]="isUnsavedChanges()" [icon]="'work'" [dropdown]="dropdown"></app-toolbar-button>
  }


<mat-menu #groupItemsMenu="matMenu">
    <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.REMOVE_GROUPS])" [disabled]="!isGrouped">
        <mat-icon [fontIcon]="getIcon(FUNCTION.REMOVE_GROUPS)"></mat-icon>
        {{buttonName(FUNCTION.REMOVE_GROUPS)}}
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.CREATE_GROUPS], GROUP_TYPE.BY_TAG)" [disabled]="!selectedTagGroup || isGrouped">
        <mat-icon>local_offer</mat-icon>
        Group by tag
    </button>

    @if (isOrganisationLinqset()) {
        <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.CREATE_GROUPS], GROUP_TYPE.BY_FUNCTION)" [disabled]="isGrouped">
            <mat-icon>functions</mat-icon>
            Group by function
        </button>        
    }@else {
        <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.CREATE_GROUPS], GROUP_TYPE.SUMMARY)" [disabled]="isGrouped">
            <mat-icon>summarize</mat-icon>
            Summarize
        </button>
        <!--button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.CREATE_GROUPS], GROUP_TYPE.BY_AI)" [disabled]="isGrouped">
            <mat-icon>network_intelligence</mat-icon>
            Use AI
        </button-->
        <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.CREATE_GROUPS], GROUP_TYPE.BY_ACTION)" [disabled]="isGrouped">
            <span style="display:flex;flex-wrap: nowrap;gap:10px;align-items: center;">
                <app-node-svg [type]="NODE_TYPE.ACTION"/>
                Group by action
            </span>
        </button>
        <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.CREATE_GROUPS], GROUP_TYPE.BY_VALUE)" [disabled]="isGrouped">
            <mat-icon>trending_up</mat-icon>
            Group by value
        </button>
    }
</mat-menu>

@if (!app.mediumScreen && !linqset.isTutorial()) {
  @if (!dropdown && !isOrganisationLinqset()) {
    <div class="demo-separator"></div>
  }
  @if (dropdown) {
    <mat-divider></mat-divider>
  }
}

@if (showButton(FUNCTION.RECALCULATE_INSIGHTS)) {
  <app-toolbar-button [icon]="getIcon(FUNCTION.RECALCULATE_INSIGHTS)" [name]="buttonName(FUNCTION.RECALCULATE_INSIGHTS)" [ariaLabel]="buttonDescription(FUNCTION.RECALCULATE_INSIGHTS)" (buttonClickEvent)="buttonClick(functionMap[FUNCTION.RECALCULATE_INSIGHTS])" [disabled]="isDisabled(FUNCTION.RECALCULATE_INSIGHTS) || isGrouped" [dropdown]="dropdown"></app-toolbar-button>
}

@if (showButton(FUNCTION.SELECT_TAG)) {
  @if (!readonlyGraph && !isOrganisationLinqset()) {
    <app-toolbar-button name="Tag selected action nodes" ariaLabel="Applies the selected tag to the selected nodes" [triggerFor]="applyTagsMenu" icon="sell" [dropdown]="dropdown"></app-toolbar-button>
  }
  <mat-menu #applyTagsMenu="matMenu">
    <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.REMOVE_TAGS])">
      <mat-icon>delete</mat-icon>
      <span>{{buttonName(FUNCTION.REMOVE_TAGS)}}</span>
    </button>
    <mat-divider></mat-divider>
    @for (t of getTags(); track t) {
      <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.SELECT_TAG], t._key)">
        <img [src]="getTagIcon(t)" width="16" style="padding-right:10px;"/>
        <span>{{t.name}}</span>
      </button>
    }
  </mat-menu>
  @if (dropdown && !isOrganisationLinqset()) {
    <mat-divider></mat-divider>
  }
}

@if (showButton(FUNCTION.APPLY_FILTER)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.APPLY_FILTER]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)" [disabled]="isGrouped"></app-toolbar-button>
}
@if (showButton(FUNCTION.CLEAR_FILTER)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.CLEAR_FILTER]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)" [disabled]="isGrouped"></app-toolbar-button>
}

@if (showButton(FUNCTION.MOVE_SELECTION_TO_MODEL)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.MOVE_SELECTION_TO_MODEL]" [disabled]="isUnsavedChanges()" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}

@if (!dropdown && !isOrganisationLinqset() && !linqset.isTutorial()) {
  <div class="demo-separator"></div>
  @if (dropdown) {
    <mat-divider></mat-divider>
  }
}

@if (showButton(FUNCTION.TOGGLE_TEMPORAL_MODEL)) {
    <app-toolbar-button  [icon]="getIcon(FUNCTION.TOGGLE_TEMPORAL_MODEL)" [name]="buttonName(FUNCTION.TOGGLE_TEMPORAL_MODEL)" [ariaLabel]="buttonDescription(FUNCTION.TOGGLE_TEMPORAL_MODEL)" (buttonClickEvent)="buttonClick(functionMap[FUNCTION.TOGGLE_TEMPORAL_MODEL])" [disabled]="isGrouped || isDisabled(FUNCTION.TOGGLE_TEMPORAL_MODEL)" [dropdown]="dropdown"></app-toolbar-button>
}

@if (showButton(FUNCTION.OPEN_MODELLING_AI)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.OPEN_MODELLING_AI]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)" icon="wand_stars"></app-toolbar-button>

    @if (!dropdown && !isOrganisationLinqset() && !linqset.isTutorial()) {
    <div class="demo-separator"></div>
    @if (dropdown) {
        <mat-divider></mat-divider>
    }
    }
}

@if (showButton(FUNCTION.TOGGLE_HEATMAP)) {
  <app-toolbar-button [function]="functionMap[FUNCTION.TOGGLE_HEATMAP]" [dropdown]="dropdown" (buttonClickEvent)="buttonClick($event)"></app-toolbar-button>
}
@if (showButton(FUNCTION.MANAGE_LABELS)) {
  <app-toolbar-button [name]="buttonName(FUNCTION.MANAGE_LABELS)" [triggerFor]="labelsMenu" [disabled]="isDisabled(FUNCTION.MANAGE_LABELS)" [icon]="getIcon(FUNCTION.MANAGE_LABELS)" [dropdown]="dropdown"></app-toolbar-button>
}
<mat-menu #labelsMenu="matMenu">
  <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.MANAGE_LABELS])">
    <mat-icon>label_off</mat-icon>
    <span>Hide labels</span>
  </button>
  @for (t of getLabelFieldTypes(); track t) {
    <button mat-menu-item (click)="buttonClick(functionMap[FUNCTION.MANAGE_LABELS], t)">
      <mat-icon>{{t === selectedLabel ? 'check' : ''}}</mat-icon>
      <span>{{t}}</span>
    </button>
  }
</mat-menu>
@if (!dropdown && selectedLabel && selectedLabel !== INSIGHTS_FIELD.NONE) {
  <span class="current-label" [matTooltip]="'Node labels show ' + selectedLabel">{{selectedLabel}}</span>
}
